import { useEffect, useState } from "react";
import Signup from "../Signup";
import Login from "../Login";
import "./AuthModal.css";

const AuthModal = ({ isOpen, onClose }) => {
  const [view, setView] = useState("signup"); // signup | login

  // Lock background scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        
        {/* ❌ CLOSE */}
        <button className="auth-close" onClick={onClose}>✕</button>

        {/* TOGGLE HEADER */}
        <div className="auth-switch">
          <button
            className={view === "signup" ? "active" : ""}
            onClick={() => setView("signup")}
          >
            Sign Up
          </button>
          <button
            className={view === "login" ? "active" : ""}
            onClick={() => setView("login")}
          >
            Login
          </button>
        </div>

        {/* CONTENT */}
        {view === "signup" ? (
          <>
            <Signup compact closeModal={onClose} />
            <p className="switch-text">
              Already have an account?{" "}
              <span onClick={() => setView("login")}>Login</span>
            </p>
          </>
        ) : (
          <>
            <Login closeModal={onClose} />
            <p className="switch-text">
              New here?{" "}
              <span onClick={() => setView("signup")}>Create account</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthModal;
